"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEANUP_LOCAL_TASKLIST_MOVE = exports.CLEANUP_REMOTE_TASKLIST_MOVE = void 0;

/*
    -> Alongside handball-libs, these jobTypes are also referenced by Handball-Cloud-Functions
*/
var CLEANUP_REMOTE_TASKLIST_MOVE = 'CLEANUP_REMOTE_TASKLIST_MOVE';
exports.CLEANUP_REMOTE_TASKLIST_MOVE = CLEANUP_REMOTE_TASKLIST_MOVE;
var CLEANUP_LOCAL_TASKLIST_MOVE = 'CLEANUP_LOCAL_TASKLIST_MOVE';
exports.CLEANUP_LOCAL_TASKLIST_MOVE = CLEANUP_LOCAL_TASKLIST_MOVE;



//////////////////
// WEBPACK FOOTER
// ../handball-libs/libs/pounder-firebase/jobTypes/index.js
// module id = 1058
// module chunks = 0